import { Environment } from '../environments';
import { buildUri } from './utils/buildUri';

const CLOUDFRONT_URI_PARAMETERIZED = 'http://(env.)biwlearning-hoya.com';
const CLOUDFRONT_URI_PROD = 'https://www.hoyavisionlearningcenter.com';

export const buildCloudFrontUri = ( env ) => (
    ( env === Environment.PROD )
        ? CLOUDFRONT_URI_PROD
        : buildUri(
            CLOUDFRONT_URI_PARAMETERIZED,
            { env: env },
        )
);
